<template>
  <div id="app" ref="app">
    <router-view />
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {
    window.alert = async (msg, obj) => {
      const opt = {
        dangerMsg: "",
        okTitle: "예",
        centered: true,
        size: "sm",
        autoFocusButton: "ok",
        returnFocus: this.$refs.app,
        hideHeaderClose: false,
        headerCloseContent: `<i class="icon icon-times text-24 text-black"></i>`,
        title: "알림",
        ...obj,
      };
      const msgVNode =
        typeof msg === "string"
          ? this.$createElement("div", {
              domProps: {
                innerHTML: `
        <p class="mb-1 text-14 lh-200 text-center">${msg}</p>
        <p class="m-0 text-gray-6 text-13 lh-200 text-center ${opt.moreMsg ? "d-block" : "d-none"}">${opt.moreMsg}</p>
      `,
              },
            })
          : msg;
      return await this.$bvModal.msgBoxOk([msgVNode], opt);
    };
    window.confirm = async (msg, html, options) => {
      const opt = {
        titleClass: "text-center font-weight-normal text-14",
        hideHeader: true,
        hideHeaderClose: true,
        headerClass: "border-0 pt-4 px-4 pb-0",
        dangerMsg: "",
        bodyClass: "p-4",
        contentClass: "border-0 shadow py-3",
        footerClass: "border-0 justify-content-center pt-0",
        cancelTitle: "취소",
        okTitle: "확인",
        cancelVariant: "outline-gray-da confirm-btn text-14 text-center py-2 px-4 mx-2 mb-2 text-dark",
        okVariant: "primary confirm-btn text-14 text-center py-2 px-4 mx-2 mb-2 text-nowrap",
        centered: true,
        size: "sm",
        noCloseOnBackdrop: true,
        autoFocusButton: "ok",
        title: "",
        hideBackdrop: true,
        ...options,
      };
      const msgVNode = this.$createElement("div", {
        domProps: {
          className: "text-center",
          innerHTML: `
              <h6 class="text-16 fw-600
              ${html ? "mb-3" : "py-3"}
              ">${msg}</h6>
              <span class="text-14 text-gray-4
               ${html ? "d-block" : "d-none"}
              ">
              ${html}
              </span>
            `,
        },
      });
      return await this.$bvModal.msgBoxConfirm([msgVNode], opt);
    };
    // window.prompt = async (msg, old) => {
    //   let input;
    //   input = old;
    //   const opt = {
    //     titleClass: "text-center font-weight-normal text-14",
    //     hideHeader: true,
    //     hideHeaderClose: true,
    //     headerClass: "border-0 pt-4 px-4 pb-0",
    //     dangerMsg: "",
    //     bodyClass: "p-4",
    //     contentClass: "border-0 shadow py-3",
    //     footerClass: "border-0 justify-content-center pt-0",
    //     cancelTitle: "취소",
    //     okTitle: "확인",
    //     cancelVariant: "outline-gray-da confirm-btn text-14 text-center py-2 px-4 mx-2 mb-2 text-dark",
    //     okVariant: "primary confirm-btn text-14 text-center py-2 px-4 mx-2 mb-2",
    //     centered: true,
    //     size: "sm",
    //     noCloseOnBackdrop: true,
    //     autoFocusButton: "ok",
    //     title: "",
    //     hideBackdrop: true,
    //     ok: (evt) => {
    //       console.log("%cApp.vue line:100 evt, input", "color: #007acc;", evt, input);
    //       return input;
    //     },
    //   };
    //   const msgVNode = this.$createElement("div", {
    //     domProps: {
    //       className: "text-center",
    //       innerHTML: `
    //           <h6 class="text-16 fw-600">${msg}</h6>
    //           <input class="form-control mt-2 mb-3" type="text" value="${input}"/>
    //         `,
    //     },
    //   });
    //   return await this.$bvModal.msgBoxConfirm([msgVNode], opt);
    // };
  },
  methods: {
    async toast(
      msg,
      opt = {
        id: "toast",
        variant: "primary",
        textVariant: "white",
      }
    ) {
      const h = this.$createElement;

      const bodyNode = h("div", {
        class: "px-2",
        domProps: {
          innerHTML: `
          <div class="text-${opt.textVariant}">
            <span class="text-13 fw-500">${msg}</span>
          </div>
          `,
        },
      });

      this.$bvToast.toast(bodyNode, {
        solid: true,
        noCloseButton: true,
        headerClass: `bg-${opt.variant} p-0 border-0 text-white fw-600`,
        bodyClass: `bg-${opt.variant} py-3 border-0 rounded text-white fw-600`,
        toastClass: "border-0  pt-0",
        // toaster: "b-toaster-bottom-right",
        toaster: "b-toaster-bottom-left",
      });
    },
  },
  async mounted() {
    window.wToast = this.toast;
    window.addEventListener("keydown", function(e) {
      if (e.key === "s" && (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)) {
        e.preventDefault();
      }
    }, false);

  },
};
</script>

<style lang="scss">
p{
  margin-bottom:0 !important;
}
.b-toaster-bottom-right{
  bottom:100px;
}
/* 모든 모달의 z-index를 높임 */
.modal {
  z-index: 10003 !important;
}

/* 배경 dim 처리도 함께 조정 */
.modal-backdrop {
  z-index: 10002 !important;
}
</style>
